import { html as v1Html } from 'src/assets/content/terms/v1.md'
import { html as v2Html } from 'src/assets/content/terms/v2.md'

export const LATEST_TERMS_VERSION = 'v2'

const TERMS_HTML = {
  v1: v1Html,
  v2: v2Html,
}

export function isKnownTermsVersion(version) {
  return version in TERMS_HTML
}

export function getTermsHtml(version) {
  return TERMS_HTML[version] ?? null
}
